export default {
  rateExceeded: 'Límite de solicitudes sobrepasado. La aplicación se cerrará en {ttl} segundos.',
};
